import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

// COMPONENTS
import Header from './components/Header';
import BottomHeader from './components/BottomHeader';
import Footer from './components/Footer';
import BottomFooter from './components/BottomFooter';
import AdminRoute from './components/AdminRoute';
import ProtectedRoute from './components/ProtectedRoute';

// ADMIN PAGES
import Dashboard from './pages/Dashboard';
import DesignSubmissions from './pages/DesignSubmission';
import Instructions from './pages/Instructions';
import Messages from './pages/Messages';
import OrderList from './pages/OrderList';
import ProductList from './pages/ProductList';
import ProductEdit from './pages/ProductEdit';
import UserList from './pages/UserList';
import UserEdit from './pages/UserEdit';

// ADMIN EDIT PAGES
import AboutContentEdit from './pages/AboutContentEdit';
import FAQQuestionsContentEdit from './pages/FAQQuestionsContentEdit';
import DesignContentEdit from './pages/DesignContentEdit';
import HomeContentEdit from './pages/HomeContentEdit';
import ProductMagContentEdit from './pages/ProductMagContentEdit';

// PAGES
import About from './pages/About';
import Cart from './pages/Cart'; // step 1
import Contact from './pages/Contact';
import Design from './pages/Design';
import FAQQuestions from './pages/FAQQuestions';
import Gallery from './pages/Gallery';
import Home from './pages/Home';
import Jig from './pages/Jig';
import Learn from './pages/Learn';
import PaymentMethod from './pages/PaymentMethod'; // step 3
import PlaceOrder from './pages/PlaceOrder'; // step 4
import ProductMag from './pages/ProductMag';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import Search from './pages/Search';
import ShippingAddress from './pages/ShippingAddress'; // step 2
import Signin from './pages/Signin';
import Signup from './pages/Signup';
import SoldGallery from './pages/SoldGallery';

// USER PROTECTED PAGES
import OrderDetails from './pages/OrderDetails';
import OrderHistory from './pages/OrderHistory';
import Profile from './pages/Profile';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <BottomHeader />
      <main className='mt-0'>
        <Routes>
          <Route path='/about' element={<About />} />
          <Route path='/jig' element={<Jig />} />
          <Route path='/product/:slug' element={<ProductMag />} />
          <Route path='/cart' element={<Cart />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/design' element={<Design />} />
          <Route path='/FAQQuestions' element={<FAQQuestions />} />
          <Route path='/forget-password' element={<ForgetPassword />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/learn' element={<Learn />} />
          <Route path='/payment' element={<PaymentMethod />} />
          <Route path='/search' element={<Search />} />
          <Route path='/shipping' element={<ShippingAddress />} />
          <Route path='/signin' element={<Signin />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/soldGallery' element={<SoldGallery />} />

          {/* Protected Routes */}
          <Route
            path='/profile'
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route path='/placeorder' element={<PlaceOrder />} />
          <Route
            path='/order/:id'
            element={
              <ProtectedRoute>
                <OrderDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path='/orderhistory'
            element={
              <ProtectedRoute>
                <OrderHistory />
              </ProtectedRoute>
            }
          />
          <Route path='/reset-password/:token' element={<ResetPassword />} />

          {/* Admin Routes */}
          <Route
            path='/admin/dashboard'
            element={
              <AdminRoute>
                <Dashboard />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/orders'
            element={
              <AdminRoute>
                <OrderList />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/users'
            element={
              <AdminRoute>
                <UserList />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/products'
            element={
              <AdminRoute>
                <ProductList />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/messages'
            element={
              <AdminRoute>
                <Messages />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/product/:id'
            element={
              <AdminRoute>
                <ProductEdit />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/user/:id'
            element={
              <AdminRoute>
                <UserEdit />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/design-submissions'
            element={
              <AdminRoute>
                <DesignSubmissions />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/instructions'
            element={
              <AdminRoute>
                <Instructions />
              </AdminRoute>
            }
          />

          {/* Content Edit Screens */}
          <Route
            path='/admin/AboutContentEdit'
            element={
              <AdminRoute>
                <AboutContentEdit />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/FAQQuestionsContentEdit'
            element={
              <AdminRoute>
                <FAQQuestionsContentEdit />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/DesignContentEdit'
            element={
              <AdminRoute>
                <DesignContentEdit />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/homecontent'
            element={
              <AdminRoute>
                <HomeContentEdit />
              </AdminRoute>
            }
          />
          <Route
            path='/admin/ProductMagContentEdit'
            element={
              <AdminRoute>
                <ProductMagContentEdit />
              </AdminRoute>
            }
          />
          <Route path='/' element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <BottomFooter />
    </BrowserRouter>
  );
}

export default App;
